export type PaymentResultStatus = 'succeeded' | 'failed';

export class PaymentResult {
  constructor(
    public readonly priceId: string,
    public readonly status: PaymentResultStatus,
  ) {}
}
